 (() => {
    const GLOBAL_KEY = 'dreambabyMulticolumnTitleHeightSync';

    if (!window[GLOBAL_KEY]) {
      const syncTitleHeights = (root = document) => {
        const lists = root.querySelectorAll('.multicolumn .multicolumn-list');

        lists.forEach((list) => {
          const titles = Array.from(
            list.querySelectorAll('.multicolumn-card__info .db-flex-text > h3.inline-richtext')
          );

          if (!titles.length) return;

          titles.forEach((title) => {
            title.style.minHeight = '';
          });

          const maxHeight = titles.reduce(
            (highest, title) => Math.max(highest, Math.ceil(title.getBoundingClientRect().height)),
            0
          );

          if (!maxHeight) return;

          titles.forEach((title) => {
            title.style.minHeight = `${maxHeight}px`;
          });
        });
      };

      let resizeRafId = null;
      const onResize = () => {
        if (resizeRafId) cancelAnimationFrame(resizeRafId);
        resizeRafId = requestAnimationFrame(() => syncTitleHeights());
      };

      window[GLOBAL_KEY] = {
        sync: syncTitleHeights,
      };

      window.addEventListener('resize', onResize);
      document.addEventListener('shopify:section:load', (event) => {
        syncTitleHeights(event.target || document);
      });

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => syncTitleHeights(), { once: true });
      } else {
        syncTitleHeights();
      }
    } else {
      window[GLOBAL_KEY].sync();
    }
  })();